module.exports = __webpack_public_path__ + "static/media/kitchen.6300c6b7.png";